module.exports = __webpack_public_path__ + "static/media/5_talking.a2990184.jpg";